import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import * as Yup from "yup"
import "./index.css"

const ContactSchema = Yup.object().shape({
  vorname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("First Name is Required"),
  nachname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Last Name is Required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Email is Required"),
})

class NewsletterForm extends Component {
  handleSubmit = values => {
    alert(JSON.stringify(values))
    console.log("submitted values :::::>", values)
  }

  render() {
    return (
      <Formik
        initialValues={{
          vorname: "",
          nachname: "",
          email: "",
          // policy: false,
        }}
        validationSchema={ContactSchema}
        onSubmit={this.handleSubmit}
      >
        {({ errors, touched }) => (
          <Form className="mb-0">
            <div className="news-letter-input-wrap d-flex justify-content-center">
              <div className="row newsletter-input-fields">
                <div className="form-group col-md-4 newsletter-input-col">
                  <label>VORNAME</label>
                  <Field
                    type="text"
                    className={
                      errors.vorname && touched.vorname
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    name="vorname"
                  />
                  {errors.vorname && touched.vorname ? (
                    <div className="invalid-feedback">{errors.vorname}</div>
                  ) : null}
                </div>
                <div className="form-group col-md-4 newsletter-input-col">
                  <label>NACHNAME</label>
                  <Field
                    type="text"
                    className={
                      errors.nachname && touched.nachname
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    name="nachname"
                  />
                  {errors.nachname && touched.nachname ? (
                    <div className="invalid-feedback">{errors.nachname}</div>
                  ) : null}
                </div>
                <div className="form-group col-md-4 newsletter-input-col">
                  <label>E-MAIL</label>
                  <Field
                    type="email"
                    className={
                      errors.email && touched.email
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    name="email"
                  />
                  {errors.email && touched.email ? (
                    <div className="invalid-feedback">{errors.email}</div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="row mt-4 mb-4">
              <div className="col">
                <div className="form-check">
                  <Field
                    type="checkbox"
                    className="form-check-input"
                    name="policy"
                    id="policyCheck"
                  />
                  <label
                    className="form-check-label newsletter-policy-check"
                    htmlFor="policyCheck"
                  >
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley of
                    type and scrambled.
                  </label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 text-center">
                <button type="submit" className="newsletter-submit-btn">
                  ABSCHICKEN
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default NewsletterForm
